const { MAX_IMAGE_SIZE, MAX_VIDEO_SIZE, MAX_FILE_SIZE, FILETYPES, VIDEOTYPES } = require('@/contants');
const { toast } = require('react-toastify');

const handleDragIn = (event, { setIsDragging, dragCounterRef }) => {
    event.preventDefault();
    event.stopPropagation();
    dragCounterRef.current += 1;
    if (dragCounterRef.current === 1 && event.dataTransfer.items && event.dataTransfer.items.length > 0) {
        setIsDragging(true);
    }
};
const handleDragOut = (event, { setIsDragging, dragCounterRef }) => {
    event.preventDefault();
    event.stopPropagation();
    dragCounterRef.current -= 1;
    if (dragCounterRef.current <= 0) {
        setIsDragging(false);
    }
};
const handleDrag = (event) => {
    event.preventDefault();
    event.stopPropagation();
};

const handleDrop = (event, { setIsDragging, dragCounterRef, ...rest }) => {
    try {
        event.preventDefault();
        event.stopPropagation();
        dragCounterRef.current = 0;
        setIsDragging(false);
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            let e = {};
            e.target = {};
            e.target.files = event.dataTransfer.files;
            let fileDataType = event.dataTransfer.files[0].type;
            let type = '';
            if (fileDataType.startsWith('image')) {
                type = 'Image';
            } else if (fileDataType.startsWith('video') || fileDataType.startsWith('audio')) {
                type = 'Video';
            } else {
                type = 'File';
            }
            handleFile(e, type, { ...rest });
            event?.dataTransfer.clearData();
        }
    } catch (error) {
        console.error(error);
        toast.error('Something went wrong');
    }
};

const handleFile = async (e, fileType, { chatFileType,
    setChatFileType, setFileLoading, files, setFiles }) => {
    setFileLoading(true);
    let fileSizeMB = 1024 * 1024;
    const VALIDiMAGEEXTENSIONS ='.jpg, .jpeg, .gif, .png';

    let maxFileSize, validFileExtension;
    if ((files ||[])?.length === 0 || !fileType) {
        if (fileType === 'Image') {
            maxFileSize = MAX_IMAGE_SIZE;
            validFileExtension = VALIDiMAGEEXTENSIONS;
            setChatFileType('Image');
        } else if (fileType === 'Video') {
            maxFileSize = MAX_VIDEO_SIZE;
            validFileExtension = VIDEOTYPES;
            setChatFileType('Video');
        } else if (fileType === 'File') {
            maxFileSize = MAX_FILE_SIZE;
            validFileExtension = FILETYPES;
            setChatFileType('File');
        }
    } else {
        if (chatFileType === 'Image') {
            maxFileSize = MAX_IMAGE_SIZE;
            validFileExtension = VALIDiMAGEEXTENSIONS;
        } else if (chatFileType === 'Video') {
            maxFileSize = MAX_VIDEO_SIZE;
            validFileExtension = VIDEOTYPES;
        } else if (chatFileType === 'File') {
            maxFileSize = MAX_FILE_SIZE;
            validFileExtension = FILETYPES;
        }
    }

    let validFiles = [];

    for (const key of Object.keys(e.target.files)) {
        let targetFile = e.target.files[key];
        let ext = targetFile.name?.slice(((targetFile.name.lastIndexOf('.') - 1) >>> 0) + 2);

        if (targetFile && targetFile.size < maxFileSize * fileSizeMB) {
            if (validFileExtension.includes(ext)) {
                validFiles.push(targetFile);
                targetFile = null;
            } else {
                toast.warn(`Invalid file type, Valid Files: ${validFileExtension}. Detected ${ext}`);
                targetFile = null;
            }
        } else {
            toast.warn(`File must be less than ${maxFileSize}mb`);
            targetFile = null;
        }
    }
    setFiles((prev) => {
        const existingFiles = Array.isArray(prev) ? prev : [];
        const newUniqueFiles = validFiles.filter((vf) =>
            !existingFiles.some((ef) => ef.name === vf.name && ef.lastModified === vf.lastModified && ef.size === vf.size)
        );
        return [...existingFiles, ...newUniqueFiles];
    });
    setFileLoading(false);
};

export const fileUploadService = {
    handleDragIn,
    handleDragOut,
    handleDrag,
    handleDrop,
    handleFile,
};
